import React from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { Modal, Box, Typography, Stack, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { closeModal } from '../store/actions/modalActions';
import { useResponsive } from '../hooks/useResponsive';
import { FontAwesomeSvgIcon } from './FontAwesomeSvgIcon';

export const ModalZone = () => {
  /**
   * Accessibility infos: https://www.w3.org/WAI/ARIA/apg/patterns/dialogmodal/
   *                      https://www.accede-web.com/notices/interface-riche/fenetres-modales/
   */
  const { open, zone, des, image, credits, imageDes } = useSelector(state => state.modalZone); 
  const dispatch = useDispatch();
  const { isMobile } = useResponsive();
  const {t} = useTranslation();

  const markup = { __html: `<p>${des}</p>` };

  const handleCloseModal = () => {
    dispatch(closeModal());
  };
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: isMobile ? '80%' : 600  ,
    bgcolor: 'background.paper',
    borderRadius: '1em',
    boxShadow: 24,
    paddingX: 4,
    paddingBottom: 4,
    outline: 'none',
    maxHeight:'85%',
    minWidth: isMobile ? '80%' : 600, 
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '4px'
    },
    '&::-webkit-scrollbar-track': {
      width: '2px',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '0.5em',
      backgroundColor: 'gray'
    }

  };

  return (
    <Modal
      id='modal_zone'
      open={open}
      onClose={() => handleCloseModal()}
      aria-labelledby="modal-zone-title"
      aria-describedby="modal-zone-description"
      role="dialog" 
      aria-modal="true"
    >
      <Box sx={style}>
        <Box sx={{ 
          display: 'flex', 
          width: '100%',
          top: 0,
          justifyContent: 'flex-end',
          backgroundColor: 'inherit',
          position: 'sticky', 
          zIndex: 100
        }}>
          <Button aria-label={t('common.close-modal')} variant='text' sx={{backgroundColor: 'white', marginTop:'0.5em'}} onClick={() => handleCloseModal()}>
            <FontAwesomeSvgIcon sx={{fontSize: '2em',}} icon={faTimes} />
          </Button>
        </Box>
        <Stack sx={{display: 'flex', maxHeigth:'80%'}} direction='column' spacing={2}>
          <Box sx={{alignSelf: 'center'}}>
            <Typography id="modal-zone-title" variant="h4" component="h1">
              {zone}
            </Typography>
          </Box>
          { image && credits &&

              <figure role="figure" 
                aria-label={credits} 
                style={{
                  width: '100%',
                  height: isMobile ? 250: 400, 
                  position: 'relative'
                }}
              >
                <Box
                  component="img"
                  sx={{
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    left: 0,
                    top: 0,
                    objectFit: 'cover',
                    position: 'relative',
                    zIndex: -1
                  }}
                  alt={imageDes}
                  src={image}
                />
                <figcaption 
                  style = {{
                    position: 'absolute',
                    bottom:'0.2em',
                    left:'0.2em', 
                    fontFamily: 'Luciole', 
                    fontSize:'0.7em', 
                    backgroundColor:'white', 
                    opacity: '0.8', 
                    paddingTop:'0.2em',
                    paddingX:'0.2em',
                    borderRadius: '0.2em'
                  }}
                >
                  {credits}
                </figcaption>
              </figure>
          }
          { image && !credits &&
            <Box
              sx={{
                width: '100%',
                height: isMobile ? 250: 400, 
                position: 'relative'
              }}>
              <Box
                component="img"
                sx={{
                  display: 'block',
                  width: '100%',
                  height: '100%',
                  left: 0,
                  top: 0,
                  objectFit: 'cover',
                  position: 'relative',
                  zIndex: -1
                }}
                alt=""
                src={image}
              />
            </Box>
          }
          {des && (
            <Box sx={{width: '100%', justifyContent: 'center'}}>
              <Typography 
                id="modal-zone-description" 
                sx={{whiteSpace: 'pre-line'}} 
                dangerouslySetInnerHTML={markup}
              />
            </Box>
          )}
        </Stack>
      </Box>
    </Modal>
  );
};